let customerEmail = window.localStorage.getItem("email");

const state = {
  currentUser: null,
  userProfile: {},
  customerEmail: customerEmail ? customerEmail : ""
};

const ROLE_OWNER = "OWNER";
const ROLE_MANAGER = "MANAGER";
const ROLE_WAITER = "WAITER";

const mutations = {
  setCurrentUser(state, val) {
    state.currentUser = val;
  },
  setUserProfile(state, val) {
    const userProfile = val !== undefined ? val : {};
    state.userProfile = userProfile;
    window.localStorage.setItem("userProfile", JSON.stringify(userProfile));
  },
  setCustomerEmail(state, val) {
    state.customerEmail = val;
    window.localStorage.setItem("email", val);
  }
};

const actions = {
  clearAdminData({ commit }) {
    commit("setCurrentUser", null);
    commit("setUserProfile", {});
  }
};

const getters = {
  hasRoleOwner: state => {
    let roles = state.userProfile.roles
      ? state.userProfile.roles
      : JSON.parse(localStorage.getItem("userProfile")).roles;

    let exist = false;
    if (roles !== undefined) {
      roles.forEach(role => {
        if (role === ROLE_OWNER) {
          exist = true;
        }
      });
    }

    return exist;
  },
  hasRoleManager: state => {
    let roles = state.userProfile.roles
      ? state.userProfile.roles
      : JSON.parse(localStorage.getItem("userProfile")).roles;

    let exist = false;
    if (roles !== undefined) {
      roles.forEach(role => {
        if (role === ROLE_MANAGER) {
          exist = true;
        }
      });
    }

    return exist;
  },
  hasRoleWaiter: state => {
    let roles = state.userProfile.roles
      ? state.userProfile.roles
      : JSON.parse(localStorage.getItem("userProfile")).roles;

    let exist = false;
    if (roles !== undefined) {
      roles.forEach(role => {
        if (role === ROLE_WAITER) {
          exist = true;
        }
      });
    }

    return exist;
  },
  getEmail: state => (isAdmin = false) => {
    return isAdmin && state.userProfile
      ? state.userProfile.email
      : state.customerEmail;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
